import * as Sentry from "@sentry/react";
import { IconBug } from "@tabler/icons-react";

import { Container } from "#shared/view/components/Container";
import { Group } from "#shared/view/components/Group";
import { Space } from "#shared/view/components/Space";
import { Text } from "#shared/view/components/Text";
import { Title } from "#shared/view/components/Title";
import { Button } from "#shared/view/designSystem/Button";

// oxlint-disable-next-line typescript/unbound-method
export const FallbackComponent: Sentry.FallbackRender = ({ error, componentStack, resetError }) => {
  return (
    <Container p="xl">
      <Group>
        <IconBug size={40} />
        <Title order={1}>Oups une erreur s'est produite !</Title>
      </Group>

      <Text>
        Nous avons bien reporté cette erreur à l'équipe technique. Nous analysons le problème dans
        les 48h.
      </Text>
      <Space h="md" />
      <Text>
        Si le problème persiste ou nécessite une attention particulière (problème bloquant,
        connexion impossible, etc...), veuillez nous contacter directement, ou à{" "}
        <a href="mailto:contact@fabera.fr">contact@fabera.fr</a>
      </Text>

      <Space h="md" />

      <Button onClick={resetError}>Revenir à l'application Fabera</Button>

      <Space h="xl" />
      <Text>Détails de l'erreur : </Text>
      <Text>{error?.toString()}</Text>
      <div>{componentStack}</div>
    </Container>
  );
};
